import { Arrow } from '@radix-ui/react-popover';
import React, { ComponentPropsWithoutRef, ElementRef, forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

/**
 * Radix draws the caret as a polygon, so it takes its colour from `fill` rather than a background —
 * and it keeps itself pointed at the trigger as the content flips sides.
 */
export const PopoverArrow = forwardRef<
  ElementRef<typeof Arrow>,
  ComponentPropsWithoutRef<typeof Arrow>
>(({ className, height = 6, width = 16, ...props }, ref) => (
  <Arrow
    className={twMerge('fill-gray-900', className)}
    height={height}
    ref={ref}
    width={width}
    {...props}
  />
));
PopoverArrow.displayName = Arrow.displayName;
